/**
 * CreateTeamModal Messages
 *
 * This contains all the text for the CreateTeamModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.teams.team';

export default defineMessages({
  createTeam: {
    id: `${scope}.create`,
    defaultMessage: 'Create Team',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Team name',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Description',
  },
  nameValidationMessage: {
    id: `${scope}.name.validation.message`,
    defaultMessage: 'Team name cannot be empty',
  },
});
